import React, { Component } from "react";
import DataTable from "react-data-table-component";

//ConfirmarOperacionTransfer
export default class ConfirmarOperacionTransfer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mensajeModal: "",
    };
  }
  componentDidMount() {}
  handleClickConfirmar = () => {
    this.props.confirmarBtn();
  };

  
  rechazarTransfer = () => {
    this.props.rechazarTransfer();
   };
  render() {
    const columns = [
      {
        name: "concepto",
        selector: row => row.concepto,
      },
      {
        name: "valor",
        selector: row => row.valor,
      },
    ];
    return (
      <div>        
        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-12">
              <section className="content">
                  <div className="row">
                  {this.props.nroOperacion!== "" && (                      
                      <div className="col-md-12" style={{textAlign: "end"}}>                                            
                        <p className="nro-operacion">
                          Número de Operación: {this.props.nroOperacion}                          
                        </p>
                      </div>
                    )}
                  </div>   
                  <div className="row">
                    <div className="col-md-8">
                      <span className="item-vef">
                        Cuenta: {this.props.detalleCuentaBox}
                      </span>
                      <div className="inner"style={{paddingTop: 2,paddingBottom: 1,}}>
                        <h6 style={{ margin: 0 }} className="item-vef">
                          Tipo: {this.props.tipoCuenta}
                        </h6>
                        <p style={{ margin: 1 }} className="item-vef">
                          Moneda: {this.props.moneda}
                        </p>
                      </div>
                    </div>                    
                  </div>

                  <br/>

                  <div className="row">     
                    <div className="col-12">
                      <DataTable
                        columns={columns}
                        data={this.props.items}
                        noTableHead={true}
                        noHeader={true}
                        customStyles={{
                          rows: { style: { minHeight: "30px"} },
                        }}
                        getTheadGroupProps={() => {
                          return { style: { display: "none" } };
                        }}
                      />
                    </div>
                  </div>

                  <br/>

                  <div className="row">
                    <div className="col-12">
                      <div className="card declaracion">
                        <p style={{fontSize:"16px"}}>
                          Declaro bajo la fe de Juramento que los fondos de
                          todas las operaciones y transacciones que realizo
                          o realizaré con la <strong>UNIVERSITARIA LTDA. </strong>
                          durante mi vinculación comercial con la
                          Institución, cualquiera sea su naturaleza,
                          denominación, condición o modalidad de las mismas,
                          provienen y/o provendrán de fuentes lícitas
                        </p>
                      </div>
                    </div>
                  </div>
                
              </section>
          </div>
        </div>
      </div>
    );
  }
}
